<script setup lang="ts">
const props = defineProps<{
  sections: PageSection[]
  template?: 'page' | 'overlay'
}>()

const processedSections = computed(() => {
  let chapterIdx = 0

  return props.sections.map((section) => {
    const isChapter = 'trumpet' in section.data && section.data.trumpet

    return {
      ...section,
      chapterIndex: isChapter ? chapterIdx++ + 1 : undefined,
    }
  })
})
</script>

<template>
  <section
    v-for="({ _type, data, chapterIndex, id }, index) in processedSections || []"
    :id="'section-' + id"
    :key="index"
    :data-type="_type"
  >
    <SectionsBigHeading
      v-if="_type === 'BigHeading'"
      :data="data || {}"
      :chapter-index="chapterIndex"
      :template="template"
    />
    <SectionsBigHeadingWithMedia
      v-else-if="_type === 'BigHeadingWithMedia'"
      :data="data || {}"
      :chapter-index="chapterIndex"
      :section-index="index"
      :template="template"
    />
    <SectionsCenteredMedia
      v-else-if="_type === 'CenteredMedia'"
      :data="data || {}"
      :section-index="index"
      :template="template"
    />
    <SectionsCta
      v-else-if="_type === 'Cta'"
      :data="data || {}"
      :chapter-index="chapterIndex"
      :template="template"
    />
    <SectionsDualMedia
      v-else-if="_type === 'DualMedia'"
      :data="data || {}"
      :section-index="index"
      :template="template"
    />
    <SectionsFullWidthMedia
      v-else-if="_type === 'FullWidthMedia'"
      :data="data || {}"
      :is-overlay="template === 'overlay'"
      :section-index="index"
      :template="template"
    />
    <SectionsHeroDualMedia
      v-else-if="_type === 'HeroDualMedia'"
      :data="data || {}"
      :template="template"
    />
    <SectionsHeroFullMedia
      v-else-if="_type === 'HeroFullMedia'"
      :data="data || {}"
      :template="template"
    />
    <SectionsLabs
      v-else-if="_type === 'Labs'"
      :data="data || {}"
      :chapter-index="chapterIndex"
      :template="template"
    />
    <SectionsLocations
      v-else-if="_type === 'Locations'"
      :data="data || {}"
      :is-overlay="template === 'overlay'"
      :chapter-index="chapterIndex"
      :template="template"
    />
    <SectionsLogos v-else-if="_type === 'Logos'" :data="data || {}" :template="template" />
    <SectionsMediaCarousel
      v-else-if="_type === 'MediaCarousel'"
      :data="data || {}"
      :template="template"
    />
    <SectionsNumberedList
      v-else-if="_type === 'NumberedList'"
      :data="data || {}"
      :chapter-index="chapterIndex"
      :template="template"
    />
    <SectionsAccordion v-else-if="_type === 'Accordion'" :data="data || {}" :template="template" />
    <SectionsHero v-else-if="_type === 'Hero'" :data="data || {}" :template="template" />

    <SectionsQuote v-else-if="_type === 'Quote'" :data="data || {}" :template="template" />
    <SectionsStats v-else-if="_type === 'Stats'" :data="data || {}" :template="template" />
    <SectionsText v-else-if="_type === 'Text'" :data="data || {}" :template="template" />
    <SectionsSectionTitle
      v-else-if="_type === 'SectionTitle'"
      :data="data || {}"
      :template="template"
    />
    <SectionsPeople v-else-if="_type === 'People'" :data="data || {}" :template="template" />
    <SectionsSplitScreen
      v-else-if="_type === 'SplitScreen'"
      :data="data || {}"
      :chapter-index="chapterIndex"
      :template="template"
    />
    <SectionsTimeline v-else-if="_type === 'Timeline'" :data="data || {}" :template="template" />
    <LazySectionsForm v-else-if="_type === 'Form'" :data="data || {}" :template="template" />
    <!-- <SectionsIntroduction v-else-if="_type === 'introduction'" :data="data || {}" /> -->
    <SectionsFactories v-else-if="_type === 'Factory'" :data="data || {}" :template="template" />
    <SectionsBlog v-else-if="_type === 'blogSection'" />
  </section>
</template>
